import { Box, Modal } from "@mui/material";
import { Close } from "@mui/icons-material";

import { ICampanhaResumo } from "../types";
import { ResumoTable } from "./Table";

interface IProps {
  isOpen: boolean;
  setIsOpen?: (isOpen: boolean) => void;
  data: ICampanhaResumo
}

export function Resumo({ isOpen, setIsOpen, data }: IProps) {

  const mockCampanhaResumo: ICampanhaResumo = {
    metrics: [
      { title: 'Total de Campanhas', value: 10, count: 100 },
      { title: 'Concluídas', value: 4, count: 10 },
      { title: 'Pendentes', value: 6, count: 20 },
    ],
    result: [
      {
        id: '001',
        nome: 'Ana Clara Souza',
        cpf: '123.456.789-00',
        parentesco: 'Titular',
        tipoCampanhas: ['Documentos'],
        dataEnvio: '2025-07-01T08:00:00Z',
        dataAbertura: '2025-07-01T09:00:00Z',
        dataConclusao: '2025-07-03T15:00:00Z',
        status: 'Concluída',
      },
      {
        id: '002',
        nome: 'Carlos Eduardo Lima',
        cpf: '234.567.890-11',
        parentesco: 'Dependente',
        tipoCampanhas: ['Retificações', 'Beneficiários'],
        dataEnvio: '2025-07-02T08:30:00Z',
        dataAbertura: '2025-07-02T10:00:00Z',
        dataConclusao: '',
        status: 'Pendente',
      },
      {
        id: '003',
        nome: 'Mariana Ferreira',
        cpf: '345.678.901-22',
        parentesco: 'Titular',
        tipoCampanhas: ['Atualização Cadastral'],
        dataEnvio: '2025-07-03T09:00:00Z',
        dataAbertura: '2025-07-03T10:15:00Z',
        dataConclusao: '2025-07-05T14:45:00Z',
        status: 'Concluída',
      },
      {
        id: '004',
        nome: 'Pedro Henrique Silva',
        cpf: '456.789.012-33',
        parentesco: 'Dependente',
        tipoCampanhas: ['Documentos'],
        dataEnvio: '2025-07-04T11:00:00Z',
        dataAbertura: '',
        dataConclusao: '',
        status: 'Pendente',
      },
      {
        id: '005',
        nome: 'Juliana Martins',
        cpf: '567.890.123-44',
        parentesco: 'Titular',
        tipoCampanhas: ['Retificações'],
        dataEnvio: '2025-07-05T08:45:00Z',
        dataAbertura: '2025-07-05T10:00:00Z',
        dataConclusao: '2025-07-06T13:30:00Z',
        status: 'Concluída',
      },
    ],
  };

  return (
    <>
      <div style={{"display":"flex","gap":"1rem"}}>
        {data.metrics.map(({ title, value, count }) => (
          <>              
            <div style={{ width: '100%', border: 'solid 1px #E8E8E8', borderRadius: '16px', padding: '0 16px 16px 16px', display: 'flex', flexDirection: 'column' }}>
              <p style={{ fontSize: '12px', lineHeight: '20px', color: '#6F6F78' }}>{title}</p>
              <span style={{ fontSize: '20px', lineHeight: '32px', fontWeight: '600', color: '#6F6F78' }}>{value}</span>
            </div>              
          </>
        ))}
      </div>

      <div style={{ marginTop: '24px' }}>
        <div>Teste</div>
        <ResumoTable data={data.result} active={true} />
      </div>
    </>
  );
}
/* GET /workspaces/:workspace_id/templates/:template_id/campaigns/:workspace_activity_id
Importante workspace_activity_id */